export default __webpack_public_path__ + "static/media/prototype-illustration.20ce3d79.svg";